import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import EmptyList from "components/common/EmptyList";
import FalconComponentCard from "components/common/FalconComponentCard";
import AssetTypeRegistrationModal from "components/modals/AssetTypeRegistrationModal";
import AssetTypeEditModal from "components/modals/AssetTypeEditModal";
import Pagination from "components/pagination";
import useApi from 'helpers/api';
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const AssetTypeRegistration = () => {
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 0,
    size: 20,
    includeInactives: false
  });
  const [types, setTypes] = useState({ content: [] });
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState(null);
  const isEmpty = !isLoading && types.content.length === 0;

  useEffect(() => {
    getData();
  }, [filters]);

  const getData = async () => {
    setIsLoading(true);
    const queryParams = new URLSearchParams(filters).toString();
    const response = await api.assetTypes.list(queryParams);
    if (response.content) setTypes(response);
    setIsLoading(false);
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Nome',
      meta: {
        headerProps: { className: 'text-900 w-75' }
      },
      cell: rowData => {
        const { id, name } = rowData.row.original;
        return (
          <span
            role="button"
            tabIndex={0}
            className="text-primary cursor-pointer"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setSelectedAssetTypeId(id);
              setShowEditModal(true);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setSelectedAssetTypeId(id);
                setShowEditModal(true);
              }
            }}
          >
            {name}
          </span>
        );
      }
    },
    {
      accessorKey: 'status',
      header: 'Status',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: rowData => {
        const { inactive } = rowData.row.original;
        return inactive ? (
          <span className="text-danger">Inativo</span>
        ) : (
          <span className="text-success">Ativo</span>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: types.content,
    columns
  });

  return (
    <>
      <AssetTypeRegistrationModal
        show={showModal}
        close={() => setShowModal(false)}
        refresh={() => getData()} />
      <AssetTypeEditModal
        show={showEditModal}
        close={() => {
          setShowEditModal(false);
          setSelectedAssetTypeId(null);
        }}
        refresh={() => getData()}
        assetTypeId={selectedAssetTypeId} />
      <FalconComponentCard>
        <FalconComponentCard.Header title="Tipos de ativo">
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={() => setShowModal(true)}
          >
            <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
            Novo
          </Button>
        </FalconComponentCard.Header>
        <FalconComponentCard.Body className="bg-white">
          <Row className="justify-content-end g-0">
            <Col className="col-auto px-3">
              <Form.Select
                size="sm"
                className="mb-3 rounded-pill"
                onChange={e =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    includeInactives: e.target.value
                  }))
                }
              >
                <option value="true">Filtro por status</option>
                <option value="true">Todos</option>
                <option value="false">Somente ativos</option>
              </Form.Select>
            </Col>
          </Row>
          {isLoading ? (
            <Skeleton count={5} height={44} baseColor="#5E6E82" />
          ) : isEmpty ? (
            <div>
              <EmptyList imgSize={400} vhSize={73} />
            </div>
          ) : (
            <>
              <AdvanceTableProvider {...table}>
                <AdvanceTable
                  table
                  headerClassName="text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                  }}
                />
              </AdvanceTableProvider>
              <Pagination
                data={types}
                filters={filters}
                setFilters={setFilters}
              />
            </>
          )}
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

export default AssetTypeRegistration;